import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function Breadcrumbs({ items, dark = false }) {
  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.label,
      ...(it.to ? { item: `${window.location.origin}${it.to}` } : {}),
    })),
  };
  return (
    <nav
      aria-label="Breadcrumb"
      className={`inline-flex rounded-full px-4 py-2 text-[15px] ${dark ? "bg-white/10 backdrop-blur-sm text-slate-200" : "bg-slate-100 text-slate-600"}`}
      data-testid="breadcrumbs"
    >
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
      <ol className="flex flex-wrap items-center gap-1.5">
        {items.map((it, i) => (
          <li key={i} className="flex items-center gap-1.5">
            {i > 0 && <ChevronRight className={`h-4 w-4 ${dark ? "text-slate-400" : "text-slate-400"}`} />}
            {it.to && i < items.length - 1 ? (
              <Link
                to={it.to}
                className={`font-medium transition-colors underline-offset-4 hover:underline ${dark ? "text-slate-100 hover:text-white" : "text-slate-700 hover:text-sky-700"}`}
              >
                {it.label}
              </Link>
            ) : (
              <span className={`font-semibold ${dark ? "text-white" : "text-slate-900"}`} aria-current="page">{it.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
